import Layout from '@/views/layout/Layout'

const cmsUniversityInfoRoutes = {
  path: '/cms/academy',
  component: Layout,
  redirect: '/cms/academy/list',
  name: 'cms.academy',
  meta: { title: '院系专业', icon: 'cms' },
  children: [
    {
      path: 'list',
      name: 'cms.academy.list',
      component: () => import('@/views/cms/academy/list'),
      meta: { title: '院系列表', icon: 'ums-admin' }
    },
    {
      path: 'create',
      name: 'cms.academy.create',
      hidden: true,
      component: () => import('@/views/cms/academy/create'),
      meta: { title: '添加院系', icon: 'ums-admin' }
    },
    {
      path: ':id/edit',
      name: 'cms.academy.edit',
      hidden: true,
      component: () => import('@/views/cms/academy/edit'),
      meta: { title: '编辑院系', icon: 'ums-admin' }
    },
    {
      path: 'major/list',
      name: 'cms.major.list',
      component: () => import('@/views/cms/major/list'),
      meta: { title: '专业列表', icon: 'ums-admin' }
    },
    {
      path: 'major/create',
      name: 'cms.major.create',
      hidden: true,
      component: () => import('@/views/cms/major/create'),
      meta: { title: '添加专业', icon: 'ums-admin' }
    },
    {
      path: 'major/:id/edit',
      name: 'cms.major.edit',
      hidden: true,
      component: () => import('@/views/cms/major/edit'),
      meta: { title: '编辑专业', icon: 'ums-admin' }
    },
  ]
}

export default cmsUniversityInfoRoutes



// WEBPACK FOOTER //
// ./src/router/module/cmsAcademyRoute.js